export class ReminderConfiguration {
    public reminderConfigurationId: number = 0;
    public reminderType: number = 0;
    public reminderPanelType: number = 0;
    public orgId: number = 0;
    public reminderStartDate: number = 0;
    public reminderSetByUser: number = 0;
    public reminderSetDate: number = 0;   
}

export class GetSetReminderConfigurationReqResp {
    public reminderConfigurations: ReminderConfiguration[] = [];
    public orgId: number = 0;
    public action: number = 0;
    public reminderPanelType: number = 0;
}
